export default __webpack_public_path__ + "static/media/tableseting.40243cab.png";